

















import { Component, Vue } from "vue-property-decorator";
import SubmitButton from "@/components/SubmitButton.vue";
import {
  getServiceSettingTask,
  saveServiceSettingTask
} from "@/api/service-api.ts";

@Component({
  components: {
    SubmitButton
  }
})
export default class ServiceSettingTask extends Vue {
  id: string | number = "";
  editable: boolean = true;
  loadDone: boolean = false;

  async mounted() {
    const res = await getServiceSettingTask();
    this.editable = !!res.editable;
    this.id = res.id as string;
    this.loadDone = true;
  }

  async submit() {
    await saveServiceSettingTask({
      id: this.id,
      editable: this.editable ? 1 : 0
    });
  }
}
